module.exports = __webpack_public_path__ + "69293ac06daa0e00ff8a35d23a738cd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C000007BJ.png
// module id = 1517
// module chunks = 0